import React from "react";
import DetailOverview from "../../components/organism/DetailOverview2";
const PageDetailOverview = () => {
  return (
    <>
      <DetailOverview />
    </>
  );
};

export default PageDetailOverview;